import { render } from "./ContactStart.vue?vue&type=template&id=444fc37a"
import script from "./ContactStart.vue?vue&type=script&lang=js"
export * from "./ContactStart.vue?vue&type=script&lang=js"
script.render = render

export default script